// Single source of truth for CoreMonit visual language.
// Matches the CoreMonit-integration/CoreMonit-figma theme exactly so this
// module is indistinguishable from the host app.

export const C = {
  bg: "#070d1a",
  surface: "#0c1424",
  surfaceHigh: "#0f1a2e",
  surfaceMid: "#111d33",

  border: "rgba(45,127,249,0.15)",
  borderBright: "rgba(45,127,249,0.35)",
  borderGlow: "rgba(45,127,249,0.6)",

  blue: "#2d7ff9",
  blueDim: "rgba(45,127,249,0.1)",
  blueMid: "rgba(45,127,249,0.2)",

  cyan: "#06b6d4",
  cyanDim: "rgba(6,182,212,0.1)",

  purple: "#8b5cf6",
  purpleDim: "rgba(139,92,246,0.1)",

  green: "#10b981",
  greenDim: "rgba(16,185,129,0.1)",

  red: "#ef4444",
  redDim: "rgba(239,68,68,0.1)",

  amber: "#f59e0b",
  amberDim: "rgba(245,158,11,0.1)",

  pink: "#ec4899",

  text: "#e8edf5",
  textSub: "#a8b8d0",
  textMuted: "#5a7399",
} as const;

export type ColorKey = keyof typeof C;

/** Semantic status → color helper used across every module. */
export const statusColor = (status: string): string => {
  switch (status) {
    case "healthy":
    case "success":
    case "synced":
    case "done":
    case "passed":
      return C.green;
    case "warning":
    case "degraded":
    case "pending":
      return C.amber;
    case "critical":
    case "error":
    case "failed":
    case "outofsync":
      return C.red;
    case "unknown":
      return C.textMuted;
    case "running":
    case "syncing":
    default:
      return C.blue;
  }
};

/** Radii used across cards / buttons / inputs. */
export const R = {
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  pill: 999,
} as const;

/** Spacing scale (px). */
export const S = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
} as const;
